import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Solution } from './components/Solution';
import { TomosAccordion } from './components/TomosAccordion';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { PurchaseSection } from './components/PurchaseSection';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Inject Meta Pixel
    const pixelId = '2782582688765590';
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      // Cleanup if needed, though usually pixel stays for the session
    };
  }, []);
  return <div className="min-h-screen bg-dark text-white font-inter selection:bg-orange-500/30" data-id="element-0">
      <Hero data-id="element-1" />
      <Solution data-id="element-2" />
      <TomosAccordion data-id="element-3" />
      <Bonuses data-id="element-4" />
      <Testimonials data-id="element-5" />
      <PurchaseSection data-id="element-6" />
      <FAQ data-id="element-7" />
      <Footer data-id="element-8" />

      <SocialProofPopup data-id="element-9" />
    </div>;
}